import { render, staticRenderFns } from "./SalarySettlementList.vue?vue&type=template&id=423c9398&scoped=true&"
import script from "./SalarySettlementList.vue?vue&type=script&setup=true&lang=js&"
export * from "./SalarySettlementList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SalarySettlementList.vue?vue&type=style&index=0&id=423c9398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c9398",
  null
  
)

export default component.exports